import styled from "styled-components";
import {HeaderNavbarMobileWrapperDefaultBox} from "./header-navbar-mobile-wrapper.default.box";

export const HeaderNavbarMobileWrapperSiBox = styled(HeaderNavbarMobileWrapperDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    background-color: ${props => props.theme.colors.brandPrimary};
    color: ${props => props.theme.colors.textLight};
  }
`